module.exports = __webpack_public_path__ + "img/floppy-disk-circle-xmark.230590d3.svg";